import { render } from "./returned.vue?vue&type=template&id=77dacb80&scoped=true"
import script from "./returned.vue?vue&type=script&lang=js"
export * from "./returned.vue?vue&type=script&lang=js"

import "./returned.vue?vue&type=style&index=0&id=77dacb80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77dacb80"]])

export default __exports__